"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmApiConfig = void 0;
exports.EvmApiConfig = {
    defaultEvmApiChain: {
        name: 'defaultEvmApiChain',
        defaultValue: '0x1',
    },
};
//# sourceMappingURL=EvmApiConfig.js.map